import { useEffect } from "react";

import useExperiment from "./useExperiment";

/**
 * Experiment hook for the SearchResultsGalleryDesign experiment. This should be used to determine
 * if the new search result gallery design should be shown.
 *
 * https://www.figma.com/design/H5txmPILhqRX1MNQqCBmSh/Search-And-Recs-Pod?node-id=922-9792&p=f&t=eSWxsbJcznftrWuE-0
 *
 */
export default function useSearchResultGalleryExperiment() {
  const { variant, trigger } = useExperiment("SearchResultsGalleryDesign");

  // Trigger the experiment wherever search results are rendered.
  useEffect(() => {
    trigger();
  }, [trigger]);

  return {
    searchResultGalleryExperimentEnabled: variant === "treatment",
  };
}
